import { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../../baseComponents/EditCardTabs'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { setVariablesToCurrentPage } from '../../../../../../../utils/reducers/reduxDispatch'
import { getProductName, parseSelectedCategories } from '../../../ProductsParent/Products/SingleProduct/function'
import MainMaterial from './Tabs/MainMaterial'
import FeaturesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/FeaturesProduct'
import OtherInformation from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/OtherInformation'
import SpecificPricesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SpecificPricesProduct'
import StockProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/StockProduct'
import SuppliersProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SuppliersProduct'
import VariantProducts from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/VariantsProduct'
import { ProductExtendedTyShort } from '../../../../../../../specificComponents/Product/types'
import WrapperProductTabs from '../../../../../../../specificComponents/Product/ProductLayout/Subcomponents/WrapperProductTabs'


type SingleMaterialProps = SingleMaterialLogicProps & ComponentWithPermissions & {}

const SingleMaterial: React.FC<SingleMaterialProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSingleMaterialLogic({ params })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainMaterial, text: t('general', 'General'), permission: 'product.material.main' },
        'stock': { component: StockProduct, text: t('stock', 'Inventario'), permission: 'product.material.stock' },
        'prices': { component: SpecificPricesProduct, text: t('prices', 'Precios'), permission: 'product.material.specificPrice' },
        'variants': { component: VariantProducts, text: t('variants', 'Variantes'), permission: 'product.material.variant'},
        'suppliers': { component: SuppliersProduct, text: t('suppliers', 'Proveedores'), permission: 'product.material.supplier' },
        'features': { component: FeaturesProduct, text: t('features', 'Características'), permission: 'product.material.features' },
        'other-information': { component: OtherInformation, text: t('otherInformation', 'Otra información'), permission: 'product.material.main' },
    }
    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} Wrapper={WrapperProductTabs} />)
}

interface SingleMaterialLogicProps {
    params: { id?: string, tab?: string }
}

const useSingleMaterialLogic = ({ params }: SingleMaterialLogicProps) => {
    const [basicData, setBasicData] = useState<ProductExtendedTyShort | null>(null)
    const id = params.id

    const getData = useCallback(async () => {
        const myData: ProductExtendedTyShort = await twinFetchPostJSON('/api/app/product/getProductInstanceComplete', {
            id,
        })
        if (myData) {
            myData['parsedCategories'] = parseSelectedCategories(myData?.CategoriesProducts)
            myData['name'] = getProductName(myData.ProductLangs)
            setBasicData(myData)
            setVariablesToCurrentPage([myData['name']])
        }
    }, [setBasicData, id])

    useEffect(() => {
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SingleMaterial